import React from 'react';
import {NavigationDots, SocialMedia} from '../components';  //will be visible in all the components that's why making hoc

const AppWrap = (Component, idName, classNames) => function HOC(){  //returning hoc, will be making it a higher order component, A higher-order component (HOC) is an advanced technique in React for reusing component logic
  return (
    <div id={idName} className={`app__container ${classNames}`}>  {/*providing classnames dynamically */}
        <SocialMedia component={classNames}/>
        <div className="app__wrapper app__flex">
            <Component/> {/*main component */}
            <div className="copyright">
                <p className="p-text" style={{ textTransform: 'none' }}>@2022 thakurprathya</p>
                <p className="p-text">All rights reserved</p>
            </div>
        </div>
        <NavigationDots active={idName}/>
    </div>
  )
}

export default AppWrap;
//now we will include this component in all components and add some code to complete work for HOC
